export default "__VITE_ASSET__D4e1h$RF__"